import React, { useEffect, useState } from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import styles from './Reviews.module.css';

const Reviews = () => {
  const [isVisible, setIsVisible] = useState(false);

  const reviews = [
    {
      id: 1,
      name: 'Priya Sharma',
      rating: 5,
      review: 'Amazing experience! The therapist was very professional and the ambiance was so relaxing. I felt completely rejuvenated after the session.',
      service: 'Aromatherapy Massage'
    },
    {
      id: 2,
      name: 'Rajesh Kumar',
      rating: 5,
      review: 'Excellent service and very hygienic environment. The couple massage was perfect for our anniversary. Highly recommended!',
      service: 'Couple Massage'
    },
    {
      id: 3,
      name: 'Anita Gupta',
      rating: 5,
      review: 'The home service was fantastic. Very convenient and the therapist was punctual and skilled. Will definitely book again.',
      service: 'Home Service'
    },
    {
      id: 4,
      name: 'Vikram Singh',
      rating: 5,
      review: 'Best spa experience in Noida! The Swedish massage was exactly what I needed after a stressful week. Great value for money.',
      service: 'Swedish Massage'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    const section = document.querySelector(`.${styles.reviews}`);
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <FaStar
        key={index}
        className={`${styles.star} ${index < rating ? styles.filled : ''}`}
      />
    ));
  };

  return (
    <section className={styles.reviews}>
      <div className={styles.container}>
        <div className={`${styles.sectionHeader} ${isVisible ? styles.fadeIn : ''}`}>
          <h2 className={styles.title}>What Our Clients Say</h2>
          <p className={styles.subtitle}>Real experiences from our valued customers</p>
        </div>

        <div className={styles.reviewsGrid}>
          {reviews.map((review, index) => (
            <div
              key={review.id}
              className={`${styles.reviewCard} ${isVisible ? styles.visible : ''}`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className={styles.cardContent}>
                <FaQuoteLeft className={styles.quoteIcon} />
                
                <div className={styles.rating}>
                  {renderStars(review.rating)}
                </div>
                
                <p className={styles.reviewText}>"{review.review}"</p>
                
                <div className={styles.reviewFooter}>
                  <div className={styles.clientInfo}>
                    <h4 className={styles.clientName}>{review.name}</h4>
                    <span className={styles.serviceType}>{review.service}</span>
                  </div>
                </div>
              </div>
              
              <div className={styles.cardGlow}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;